module.exports = __webpack_public_path__ + "fonts/Montserrat-Medium.b02dab0.woff2";